export function dob(value) {
    let number = parseInt(value, 10);
    if (isNaN(number) || number < 1 || number > 9) {
        number = value;
    }

    return number;
}